import {
  stackDirection,
  stackJustify,
  stackWrap,
  stackAlign,
  stackGap,
} from '../../theme/layout';

interface AnyStack {
  children: any;
  gap?: 'xs' | 'sm' | 'base' | 'md' | 'lg' | 'xl';
  wrap?: 'reverse' | 'wrap' | 'default';
  extensions?: string;
}

export type StackPosition =
  | 'evenly'
  | 'between'
  | 'start'
  | 'end'
  | 'center'
  | 'around';

interface HStackProps extends AnyStack {
  justify?: StackPosition;
  rowReverse?: boolean;
  onClick?: Function;
}
interface VStackProps extends AnyStack {
  align?: StackPosition;
  colReverse?: boolean;
}

interface StackProps extends HStackProps, VStackProps {
  direction:
    | 'vertical'
    | 'horizontal'
    | 'horizontal-reverse'
    | 'vertical-reverse';
}

export function HStack(props: HStackProps) {
  const { children, rowReverse, ...rest } = props;
  return (
    <Stack
      direction={rowReverse ? 'horizontal-reverse' : 'horizontal'}
      {...rest}
    >
      {children}
    </Stack>
  );
}

export function VStack(props: VStackProps) {
  const { children, colReverse, ...rest } = props;
  return (
    <Stack direction={colReverse ? 'vertical-reverse' : 'vertical'} {...rest}>
      {children}
    </Stack>
  );
}

export function Stack(props: StackProps) {
  const {
    children,
    justify,
    gap,
    wrap,
    direction,
    align,
    extensions,
    onClick,
  } = props;

  const rootStyles = `flex ${extensions || ''} ${
    stackJustify[justify || 'start']
  } ${stackWrap[wrap || 'default']} ${stackGap[gap || 'none']}
  ${stackDirection[direction]} ${stackAlign[align || 'start']}`;

  return (
    <div onClick={() => onClick && onClick()} className={rootStyles}>
      {children}
    </div>
  );
}
